import { render } from "./EditOtherModal.vue?vue&type=template&id=abc8cbc4&scoped=true"
import script from "./EditOtherModal.vue?vue&type=script&lang=js"
export * from "./EditOtherModal.vue?vue&type=script&lang=js"

import "./EditOtherModal.vue?vue&type=style&index=0&id=abc8cbc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc8cbc4"]])

export default __exports__